import React from 'react';
import { EyeSlashFill, EnvelopeFill } from 'react-bootstrap-icons';
import { useLocale } from '../i18n/LocaleContext';
import './ShopifyConnectionBanner.scss';

const ADMIN_EMAIL = 'sales@outfino.io';

export default function BrandInactiveBanner({ brand }) {
  const { t } = useLocale();
  if (!brand || brand.isActive !== false) return null;

  return (
    <div className="conn-banner conn-banner--error" role="alert" data-status="BRAND_INACTIVE">
      <span className="conn-banner__icon" aria-hidden="true">
        <EyeSlashFill size={16} />
      </span>
      <div className="conn-banner__text">
        <div className="conn-banner__title">{t('brandInactive.title')}</div>
        <div className="conn-banner__meta">
          <span className="conn-banner__reason">{t('brandInactive.body')}</span>
          <span>{t('brandInactive.contact')}</span>
        </div>
      </div>
      <a
        className="conn-banner__cta"
        href={`mailto:${ADMIN_EMAIL}?subject=${encodeURIComponent(`${t('brandInactive.mailSubject')}: ${brand.name || ''}`)}`}
      >
        <EnvelopeFill size={14} aria-hidden="true" />
        <span>{t('brandInactive.cta')}</span>
      </a>
    </div>
  );
}
